//import { OrderStatus } from "../shared/models/sections.model";
import { FlowsFiRenewalCheckoutModel } from "./flows-fi-renewal-checkout.model";

export namespace FlowsFiRenewalCheckoutAction {
  export class Focused {
    static readonly type = "[FlowsFiRenewalCheckout] Focused ";
    constructor(public payload?: FlowsFiRenewalCheckoutModel) {}
  }
  export class Disabled {
    static readonly type = "[FlowsFiRenewalCheckout] Disabled ";
  }
  export class Completed {
    static readonly type = "[FlowsFiRenewalCheckout] Completed ";
    constructor(public payload: FlowsFiRenewalCheckoutModel) {}
  }
  export class Loading {
    static readonly type = "[FlowsFiRenewalCheckout] Loading ";
  }
  export class Errorred {
    static readonly type = "[FlowsFiRenewalCheckout] Errorred";
    constructor() {}
  }
  export class Redirect {
    static readonly type = "[FlowsFiRenewalCheckout] Redirect ";
    constructor(public redirectUrl: string) {}
  }
}
